import type {PublicMethodUtils} from '@wix/document-services-types'
import type {BrowserThemeColorPublicAPI} from '@wix/document-services-public-types'
import {browserThemeColor} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<BrowserThemeColorPublicAPI> {
    return {
        methods: {
            browserThemeColor: {
                get: publicMethodUtils.defineGetter(browserThemeColor.getBrowserThemeColor),
                set: publicMethodUtils.defineDataManipulationAction(browserThemeColor.setBrowserThemeColor),
                reset: publicMethodUtils.defineDataManipulationAction(browserThemeColor.resetBrowserThemeColor),
                isSet: publicMethodUtils.defineGetter(browserThemeColor.isBrowserThemeColorSet)
            }
        }
    }
}
